import React from 'react'
import { csx, Skeleton, Stack } from '@vtex/admin-ui'

import { type SerializedData as BrandSerializedData } from './filterBrand/FilterBrand'
import { type SerializedData as CategorySerializedData } from './filterCategory/FilterCategory'
import { type SerializedData as CreatedAtSerializedData } from './filterCreatedAt/FilterCreatedAt'
import { type SerializedData as KitSerializedData } from './filterKit/FilterKit'
import { type SerializedData as SalesChannelSerializedData } from './filterSalesChannel/FilterSalesChannel'
import { type SerializedData as SellerSerializedData } from './filterSeller/FilterSeller'
import { type SerializedData as StatusSerializedData } from './filterStatus/FilterStatus'
import { type SerializedData as VisibleSerializedData } from './filterVisible/FilterVisible'

export function FilterLoading() {
  return (
    <Stack space="$space-4" className={csx({ width: '3/4' })}>
      <Skeleton className={csx({ height: 20 })} />
      <Skeleton className={csx({ width: '9/12', height: 20 })} />
      <Skeleton className={csx({ width: '10/12', height: 20 })} />
      <Skeleton className={csx({ width: '10/12', height: 20 })} />
      <Skeleton className={csx({ width: '9/12', height: 20 })} />
      <Skeleton className={csx({ width: '11/12', height: 20 })} />
    </Stack>
  )
}

export type SerializedFiltersData = {
  FilterBrand: BrandSerializedData
  FilterCategory: CategorySerializedData
  FilterCreatedAt: CreatedAtSerializedData
  FilterKit: KitSerializedData
  FilterSalesChannel: SalesChannelSerializedData
  FilterSeller: SellerSerializedData
  FilterStatus: StatusSerializedData
  FilterVisible: VisibleSerializedData
}
